(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payment/assets/javascripts/services/payment-errors.js') >= 0) return;  svs.modules.push('/components/tur/payment/assets/javascripts/services/payment-errors.js');
'use strict';

class PaymentError {
  constructor(_ref) {
    let {
      xhr
    } = _ref;
    this.setup(xhr);
  }
  setup(xhr) {
    this.response = JSON.parse(xhr.responseText);
    if (this.response.error && !this.response.error.code) {
      this.errorCode = -1;
    } else if (typeof this.response.error.code === 'number') {
      this.errorCode = this.response.error.code;
    } else {
      this.errorCode = parseInt(this.response.error.code.replace(/\s/g, ''), 10);
    }
    svs.tur.payment.logger.error("PAYMENT ERROR! Error code: ".concat(this.errorCode));
  }
  getErrorData() {
    return {
      errorType: this.getErrorType(),
      origError: this.response
    };
  }
  getErrorType() {
    const {
      ERROR_USER_SUSPENDED,
      ERROR_ACCOUNT_LOW,
      ERROR_KYC,
      ERROR_GENERIC,
      ERROR_DRAW_CLOSED
    } = svs.tur.payment.constants.apierrors;
    switch (this.errorCode) {
      case 1019:
      case 5135:
        return ERROR_USER_SUSPENDED;
      case 1006:
      case 6121:
        return ERROR_ACCOUNT_LOW;
      case 6332:
        return ERROR_KYC;
      case 8105:
      case 8107:
      case 8104:
      case 41:
        return ERROR_DRAW_CLOSED;
      default:
        return ERROR_GENERIC;
    }
  }

  showErrorDialog(onConfirm) {
    const {
      ERROR_USER_SUSPENDED,
      ERROR_ACCOUNT_LOW,
      ERROR_KYC,
      ERROR_GENERIC
    } = svs.tur.payment.constants.apierrors;
    switch (this.getErrorType()) {
      case ERROR_USER_SUSPENDED:
        this.showAccountSuspendedDialog();
        break;
      case ERROR_ACCOUNT_LOW:
        this.showAccountLowFundsDialog({});
        break;
      case ERROR_KYC:
        this.showAccountKycDialog();
        break;
      case ERROR_GENERIC:
      default:
        svs.tur.apierrors.showErrorMessage({
          response: this.response,
          onConfirm: () => {
            onConfirm && onConfirm();
          }
        });
        break;
    }
  }
  showAccountSuspendedDialog() {
    new svs.tur.payment.dialogs.UserSuspension();
  }
  showAccountLowFundsDialog(_ref2) {
    let {
      price,
      balance
    } = _ref2;
    new svs.tur.payment.dialogs.UserLowBalance({
      price,
      balance
    });
  }
  showAccountKycDialog() {
    svs.core.module.load('/cl/components/kyc-messages', null, () => {
      svs.components.kyc_messages.showKYCMessage();
    });
  }
}
svs.tur.payment.services.PaymentError = PaymentError;

 })(window);